// ==================== IMPORTS ====================
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PayPalButtons } from "@paypal/react-paypal-js";

function PaypalWebviewAuction() {
  // ==================== STATES ====================
  const [searchParams] = useSearchParams();
  const tokenId = searchParams.get("token");
  const amount = searchParams.get("amount");
  const depositType = searchParams.get("type");
  const referenceId = searchParams.get("referenceId");
  const [depositMessage, setDepositMessage] = useState(false);
  const [showPayPal, setShowPayPal] = useState(tokenId && referenceId && depositType ? true : false);

  // ==================== PAYPAL DEPOSIT FUNCTION ====================
  const handleDeposit = async (paymentResult) => {
    try {
      const webViewPayload = {
        payload: paymentResult,
        type: depositType === "application" ? "listing" : "auction",
      };
      const response = await fetch(
        `${process.env.REACT_APP_STAGE_API_URL}users/v1/paypal/deposit-via-webview`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenId}`,
          },
          body: JSON.stringify(webViewPayload),
        }
      );
      if (response?.status === 200) {
        setDepositMessage(true);
        setShowPayPal(false);
      }
    } catch (error) {
      console.error("Error depositing:", error);
    }
  };

  // ==================== PAYPAL HANDLE ERROR ====================
  function onError() {
    try {
      console.log("Error");
      setShowPayPal(false);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div
      className="influencer_enrollment_page"
      style={{
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f7f7f7",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "400px",
          maxWidth: "100%",
        }}
      >
        {/* {showPayPal &&
          (depositType === "auction" || depositType === "application") && (
          <>
            <h2
              style={{
                textAlign: "center",
                fontSize: "24px",
                marginBottom: "20px",
              }}
            >
              {depositType === "application"
                ? "Application Fee"
                : "Auction Fee"}
            </h2>
            <p>
              {" "}
              Total Charged
              <br />
              <strong> $1,500.00</strong>
            </p>
            <p> </p>
          </>
        )} */}
        {depositMessage && (
          <h2
            style={{
              textAlign: "center",
              fontSize: "24px",
              marginBottom: "20px",
              color: "red",
            }}
          >
            Note
          </h2>
        )}
        {tokenId === null ||
        referenceId === null ||
        depositType === null ||
        (depositType !== "auction" && depositType !== "application") ? (
          <div
            style={{
              maxWidth: "600px",
              margin: "40px auto",
              padding: "20px",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              backgroundColor: "#fff4f4",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              color: "#d32f2f",
              textAlign: "left",
              fontFamily: "'Roboto', sans-serif",
            }}
          >
            <h2
              style={{
                fontSize: "20px",
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              Action Required
            </h2>
            <div style={{ marginBottom: "16px" }}>
              <h3 style={{ fontSize: "18px", marginBottom: "8px" }}>
                To Pay Auction Fee:
              </h3>
              <ul style={{ marginLeft: "20px", marginBottom: "12px" }}>
                <li>You need a token.</li>
                <li>
                  Set <b>type</b> to <code>auction</code>.
                </li>
                <li>
                  Set <b>referenceId</b> to your auction ID.
                </li>
              </ul>
            </div>
            <div>
              <h3 style={{ fontSize: "18px", marginBottom: "8px" }}>
                To Pay Listing Fee:
              </h3>
              <ul style={{ marginLeft: "20px" }}>
                <li>You need a token.</li>
                <li>
                  Set <b>type</b> to <code>application</code>.
                </li>
                <li>
                  Set <b>referenceId</b> to your application ID.
                </li>
              </ul>
            </div>
          </div>
        ) : null}
        {depositMessage && (
          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.6",
              color: "#333",
              margin: "20px 0",
              textAlign: "center",
            }}
          >
            Payment Successful!.
          </p>
        )}

        {showPayPal &&
          (depositType === "auction" || depositType === "application") && (
          <PayPalButtons
          onClick={(data, actions) => {
            data.fundingSource &&
              window?.ReactNativeWebView?.postMessage(
                "open_paypal_browser"
              );
            return actions.resolve();
          }}
            createOrder={(data, actions) => {
              return actions?.order?.create({
                purchase_units: [
                  {
                    reference_id: referenceId,
                    amount: {
                      value: amount,
                      currency: "USD",
                    },
                  },
                ],
              });
            }}
            onApprove={(data, actions) => {
              return actions.order.capture().then((paymentResult) => {
                handleDeposit(paymentResult);
              });
            }}
            onError={onError}
          />
        )}
      </div>
    </div>
  );
}

export default PaypalWebviewAuction;
